// Journey manifest + resolver. This module is deliberately **renderer-free** — it
// does NOT import AssistantJourney / messageRenderers — so eager importers in the
// main chunk (App resolving a journeyId) can use it without pulling the
// whole assistant runtime into the main bundle and defeating the lazy split. The
// eager AssistantJourney is re-exported from the journeys barrel (index.js), not here.
//
// The default journey is the eager core (bundled with the shell). Every other
// journey is a **lazy loader** — a `() => import(...)` whose module is a separate
// chunk, so a journey's exclusive code (components, and in a real build-out its own
// flows/data sources) stays out of the main bundle until that journey is selected.
// Shared deps between journeys are deduped into common chunks by the bundler.
//
// A journey is NOT a device/channel (that is the orthogonal surface resolver in
// platform/config); it is a feature-set composition for a specific use case.
export const DEFAULT_JOURNEY_ID = 'default';

export const journeyLoaders = {
  'paint-color-picker': () => import('./paintColorPicker/journey'),
};

/**
 * True if `id` names a registered lazy journey (anything other than the eager default).
 * @param {string} id
 */
export const isLazyJourney = (id) => Object.prototype.hasOwnProperty.call(journeyLoaders, id);

/**
 * Resolve an entry-point journey hint to a valid journeyId. The host page selects a
 * journey via the `magic-apron-assistant.set-journey` lifecycle event (see App);
 * this normalizes that hint — an unknown or missing hint falls back to the default
 * journey, so a bad or stale hint can never leave the shell without a journey.
 * @param {string} [hint]
 */
export const resolveJourneyId = (hint) => (isLazyJourney(hint) ? hint : DEFAULT_JOURNEY_ID);
